import React, { useState, useContext, useEffect } from "react";
import { FiAlertCircle } from "react-icons/fi";
import { IoCloseSharp } from "react-icons/io5";
import { makeApiCall } from "../../config";
import AuthContext from "../../context/AuthContext";
import { ErrorToaster } from "../../utils/toaster";
import SpinnerBtn from "../SpinnerBtn";

export default function GenerateScript() {
  const [enableAlert, setEnableAlert] = useState(false);
  const [spinnerBtn, setSpinnerBtn] = useState(false);
  const [cdnUrl, setCdnUrl] = useState("");
  const { userInfo } = useContext(AuthContext);

  const handleScriptGenerate = async () => {
    setSpinnerBtn(true);
    try {
      const response = await makeApiCall("/api/v1/tracker/generate/", 'get', null, {hostname: userInfo.defaultURL, customerId: userInfo._id});
      const { cdnUrl,message } = response;
      localStorage.setItem(`${userInfo._id}_CDN`, cdnUrl);
      setCdnUrl(cdnUrl);
      setEnableAlert(true);
    } catch (error) {
      setEnableAlert(false);
      if (error.response && error.response.status === 422) {
        ErrorToaster(error.response.data.message);
      } else {
        console.log("Error occurred in handleScriptGenerate", error);
      }
    } finally {
      setSpinnerBtn(false);
    }
  }

  useEffect(() => {
    const storedCdnUrl = localStorage.getItem(`${userInfo._id}_CDN`);
    if (storedCdnUrl) {
      setCdnUrl(storedCdnUrl);
      setEnableAlert(true);
    }
  }, [userInfo._id]);

  return (
    <>
      {enableAlert && (<div
          className="flex items-center p-6 mb-4 text-green-800 rounded-lg bg-green-50 dark:bg-gray-800 dark:text-green-400"
          role="alert"
        >
          <FiAlertCircle className=" text-2xl" />
          <span className="sr-only">Info</span>
          <div className="ms-3 text-sm font-medium">
            Your CDN Script generated successfully{" "}
            <a href={cdnUrl} className="font-semibold underline hover:no-underline">
              {cdnUrl}
            </a>
            . Please ensure that you integrate this CDN into your application.
          </div>
          <button
            type="button"
            className="ms-auto -mx-1.5 -my-1.5 bg-green-50 text-green-500 rounded-lg focus:ring-2 focus:ring-green-400 p-1.5 hover:bg-green-200 inline-flex items-center justify-center h-8 w-8 dark:bg-gray-800 dark:text-green-400 dark:hover:bg-gray-700"
            onClick={() => setEnableAlert(false)}
          >
            <span className="sr-only">Close</span>
            <IoCloseSharp className=" text-2xl"  />
          </button>
        </div>
      )}

      {userInfo.defaultURL && !enableAlert && (
        <>
          {!spinnerBtn ? (
            <button
              type="button"
              onClick={handleScriptGenerate}
              className="m-2 float-right rounded-md bg-[#58439F] px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Generate Script
            </button>
          ) : (
            <SpinnerBtn style="m-2 float-right rounded-md bg-[#58439F] px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600" />
          )}
        </>
      )}
    </>
  );
}
